import React, {Component} from 'react';
import {
    Dimensions,
    StyleSheet,
    Image,
    ScrollView,
    TouchableOpacity,
    View,  Share, Platform, Alert, Linking, KeyboardAvoidingView, ImageBackground,

    TextInput
} from 'react-native';
import HMTextView from "../../../../customviews/HMTextView";
import Colors from "../../../../tools/Colors";
import {moderateScale} from "../../../../tools/Scaling";

import connect from "react-redux/es/connect/connect";
import * as NavigationService from "../../../../redux/NavigationService";

import HMListItem from "../../../../customviews/HMListItem";
import HMActionBar from "../../../../customviews/HMActionBar";
//import DialogCompetitions from "../../../../tools/DialogCompetitions";
//import HMImageBackground from "../../../../customviews/HMImageBackground";
import i18n from "../../../../I18n/i18n";
import store from "../../../../redux/store";
import PathFile from "../../../../assets/PathFile";
import {AsyngStorageClass} from "../../../../tools/AsyngStorageClass";
import HMAlert from "../../../../customviews/HMAlert";


const window = Dimensions.get('window');


class ProfileScreen extends Component {
    state = {
        showDialogCompetitions: false
    }

    constructor() {
        super();
    }

    _menu = null;

    setMenuRef = ref => {
        this._menu = ref;
    };

    hideMenu = () => {
        this._menu.hide();
    };

    showMenu = () => {
        this._menu.show();
    };

 /*   async remove() {
        store.dispatch(serviceActionSetToken(null))
        try {
            //await AsyncStorage.removeItem(IDCITY);
            await AsyncStorage.removeItem(TOKEN);
        } catch (error) {
            alert(i18n.t('constant.retry'))
        }
    }*/

    exitApp() {
        HMAlert(
            i18n.t('constant.message'),
            i18n.t('constant.WantToLogOut'),
            [
                // {text: 'Ask me later', onPress: () => {}},
                {text: i18n.t('constant.No'), onPress: () => {}, style: 'cancel'},
                {
                    text: i18n.t('constant.Yes'), onPress: () => {
                      //  this.remove()
                        AsyngStorageClass.removeToken();

                    //    NavigationService.resetTo("Drawer")
                        NavigationService.PopToPop()

                        //, NavigationService.resetTo('SplashScreen')
                    }
                },
            ],
            {cancelable: true}
        )

    }

    onShare() {
        let data = store.getState().reducerSplashGetAllData.resultsSaina.result.info;
        Share.share(
            {
                message: Platform.OS === "ios" ? data.description + "\n" + data.ios.link : data.description + "\n" + data.android.link,
                url: Platform.OS === "ios" ? data.ios.link : data.android.link,
            }
        ).then(({action, activityType}) => {
            if (action === Share.sharedAction)
                console.log('Share was successful');
            else
                console.log('Share was dismissed');
        });
    }

    render() {
        let {user, token} = store.getState().reducerSplashGetAllData;
        let checkLogin = (store.getState().reducerSplashGetAllData.TypeLogin == 2);

        // let user = store.getState().reducerSplashGetAllData.resultsSaina.results.user.name;
        return (
            <KeyboardAvoidingView style={{flex: 1, backgroundColor: Colors.backgroundColor,}} behavior={"padding"}
                                  enabled={Platform.OS === "ios"}>
          {/*      <HMImageBackground

                />
*/}
                <View style={{flex: 1}}>

                    <HMActionBar menu
                                 props={this.props} statusBarTransparent
                        // text={i18n.t('Privatizations.title')}
                                 text={i18n.t('constant.Information')}
                                 headerVisibility
                                 more_menu
                                 back
                                 onBackPress={() => this.props.navigation.pop()}

                    />
                    <ScrollView
                        style={{
                            //  backgroundColor: Colors.backgroundColor,
                        }}>

                        <View style={styles.container}>


                            <View style={{
                                // padding: moderateScale(6),
                                 width: '100%',

                               // flex: 1,
                                backgroundColor: Colors.colorPrimary,
                                height: moderateScale(140)
                            }}>
                                {/*<Image
                                    source={PathFile.image.CityTransparent}
                                    //   source={require("../../assets/img/user.png")}
                                    resizeMode="stretch"
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 0,
                                        bottom: 0,
                                        left: 0,
                                        alignSelf: 'center',
                                        width: '100%',
                                        height: moderateScale(140),
                                        //   backgroundColor: "#2d88ee",

                                        // tintColor: Colors.gray
                                    }}/>*/}
                                <Image source={PathFile.image.user}
                                       style={{
                                           alignSelf: 'center',
                                           width: moderateScale(50),
                                           height: moderateScale(50),
                                           marginTop: moderateScale(10)
                                           // tintColor: Colors.gray
                                       }}/>
                                <View style={{width: moderateScale(14)}}/>

                                <View style={{
                                    alignSelf: 'center',
                                    flexDirection: 'row',
                                    marginTop: moderateScale(8)

                                }}>

                                    <View style={{flexDirection: 'row'}}>
                                        <HMTextView text={token && user ? user.name : ''} type={'bold'}
                                                    style={{

                                                        fontSize: moderateScale(14),
                                                        color: Colors.white,
                                                        //   textAlign: "right"
                                                    }}/>
                                    </View>
                                    <View style={{width: moderateScale(6)}}/>

                                    <View style={{flexDirection: 'row'}}>
                                        <HMTextView text={token && user ? user.family : ''} type={'bold'}
                                                    style={{

                                                        fontSize: moderateScale(14),

                                                        color: Colors.white,
                                                        // textAlign: "right",
                                                        // marginVertical: moderateScale(5)
                                                    }}/>
                                    </View>
                                </View>
                                <View style={{flexDirection: 'row', alignSelf: 'center',}}>
                                    <HMTextView text={token && user ? user.mobile : ''} type={'bold'}
                                                style={{

                                                    fontSize: moderateScale(14),

                                                    color: Colors.white,
                                                    // textAlign: "right",
                                                    marginVertical: moderateScale(5)
                                                }}/>
                                </View>

                            </View>
                            {
                                checkLogin?
                                  null
                                  :
                                    <HMListItem
                                        // title={"ویرایش اطلاعات"}
                                        title={i18n.t('constant.Editing_information')}
                                        //image={require("../../assets/img/editProfile.png")}
                                        image={"md-create"}
                                        onPress={() => {
                                            this.props.navigation.navigate("ChangeInformationScreen")
                                        }}
                                    />
                            }

                            {/*   <HMListItem
                                title={"شارژ کیف پول"}
                                //  title2={"میزان اعتبار : " + this.props.wallet + " تومان )"}
                                title2={" ( میزان اعتبار : " + this.props.wallet + " تومان )"}
                                // image={require("../../assets/img/payment-method.png")}
                                image={"md-filing"}

                                onPress={() => {
                                    this.props.navigation.navigate("IncreaseCreditScreen")
                                }}
                            />*/}
                       {/*     <HMListItem
                                //title={"درخواست های من"}
                                title={i18n.t('constant.My_apply')}

                                //  image={require("../../assets/img/packing-list.png")}
                                image={"md-list"}
                                onPress={() => {
                                    this.props.navigation.navigate("ListMyApplyScreen")
                                }}
                            />*/}
                            <HMListItem
                                // title={"معرفی دوستان"}
                                title={i18n.t('constant.Introduce_friends')}

                                //   image={require("../../assets/img/add-friend.png")}
                                image={"md-share"}
                                NoShowIconOnpress
                                onPress={() => {
                                    this.onShare()
                                }}
                            />
                            {
                                checkLogin?
                                    null
                                    :
                                    <HMListItem
                                        // title={"تغییر رمز عبور"}
                                        title={i18n.t('constant.Change_Password')}

                                        //   image={require("../../assets/img/add-friend.png")}
                                        image={"lock-open"}
                                        NoShowIconOnpress
                                        onPress={() => {
                                            this.props.navigation.navigate("ChangePassScreen", {forgot_my_password: false})
                                        }}
                                    />
                            }


                            {/*<HMListItem*/}
                            {/*title={"شرکت در مسابقه"}*/}
                            {/*//   image={require("../../assets/img/add-friend.png")}*/}
                            {/*image={"md-trophy"}*/}
                            {/*NoShowIconOnpress*/}
                            {/*onPress={() => {*/}
                            {/*this.setState({*/}
                            {/*showDialogCompetitions: true*/}
                            {/*})*/}
                            {/*}}*/}
                            {/*/>*/}
                            {/*<HMListItem*/}
                            {/*title={"طراحی و توسعه هونام مهارت"} image={require("../../assets/img/add-friend.png")}*/}
                            {/*onPress={() => {*/}
                            {/*Linking.openURL(UrlHoonam).catch(err => console.error('An error occurred', err))*/}
                            {/*}}*/}
                            {/*/>*/}

                            <HMListItem
                                typeIcon={"MaterialCommunityIcons"}
                                title={"تغییر شهر"}

                                NoShowIconOnpress
                                //image={require("../../assets/img/logout.png")}
                                image={"city"}

                                onPress={() => {
                                    this.props.navigation.navigate("ListCityScreen")


                                }}
                            />

                            <HMListItem
                                title={i18n.t('constant.Exit')}

                                NoShowIconOnpress
                                //image={require("../../assets/img/logout.png")}
                                image={"md-log-out"}

                                onPress={() => {
                                    this.exitApp()


                                }}
                            />


                        </View>

                    </ScrollView>
              {/*      {
                        this.state.showDialogCompetitions ?

                            <DialogCompetitions onPressCancel={() => {
                                this.setState({
                                    showDialogCompetitions: false
                                })
                            }
                            }/>
                            :
                            null
                    }*/}

                </View>
            </KeyboardAvoidingView>

        );
    }
}

const mapStateToProps = (state) => ({
    user: state.reducerSplashGetAllData.user,
    wallet: state.reducerSplashGetAllData.wallet,
    data_splash: state.reducerSplashGetAllData,
});
export default connect(mapStateToProps, null)(ProfileScreen);

const styles = StyleSheet.create({
    container: {
        flex: 1,
        // backgroundColor: Colors.backgroundColor,
    },
    containerStyle: {
        alignSelf: 'center',
        width: window.width,
        overflow: 'hidden',
        height: window.width / 1.9
    },
    sliderContainerStyle: {
        borderRadius: window.width,
        width: window.width * 2,
        height: window.width * 2,
        marginLeft: -(window.width / 2),
        position: 'absolute',
        bottom: 0,
        overflow: 'hidden'
    },
    circle: {
        backgroundColor: Colors.light,
        width: moderateScale(80),
        height: moderateScale(80),
        alignItems: "center",
        justifyContent: "center",
        borderRadius: moderateScale(40),
        borderWidth: moderateScale(2),
        borderColor: Colors.colorPrimary
    }
});
